import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiCollectionsService } from '../../../../services/collections/api/api-collections.service';
import { AlertsService } from '../../../../services/alerts.service';
import { LanguagesService } from '../../../../services/languages/languages.service';
import { Collection } from '../../../../models/collections/collection.model';
import { CollectionReward } from '../../../../models/collections/collection-reward.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';
import { CollectionTranslationForm, buildCollectionTranslationForms, toCollectionTranslations } from '../../collection-translation-form.model';

@Component({
  selector: 'app-collection-edit-modal',
  templateUrl: './collection-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class CollectionEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  collectionId: number = 0;
  name: string = '';
  translations: CollectionTranslationForm[] = [];
  rewards: CollectionReward[] = [];
  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(
    private apiCollectionsService: ApiCollectionsService,
    private alertsService: AlertsService,
    private languagesService: LanguagesService
  ) {}

  show(collection: Collection, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.collectionId = collection.collectionId;
    this.name = collection.name;
    this.translations = buildCollectionTranslationForms(this.languagesService.languages, collection.translations);
    this.rewards = collection.rewards.map(r => {
      const reward = new CollectionReward();
      reward.rewardId = r.rewardId;
      reward.currencyType = r.currencyType;
      reward.currencyQuantity = r.currencyQuantity;
      reward.currencyTicketCost = r.currencyTicketCost;
      return reward;
    });
    this.isLoading = false;
    this.modal.show();
  }

  addReward(): void {
    const r = new CollectionReward();
    this.rewards.push(r);
  }

  removeReward(index: number): void {
    this.rewards.splice(index, 1);
  }

  save(): void {
    this.isLoading = true;
    this.apiCollectionsService.editCollection(this.collectionId, this.name, toCollectionTranslations(this.translations), this.rewards).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Collection updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating collection : ' + error);
      }
    );
  }
}
